import { Box } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DataGrid, GridColDef, GridPaginationModel } from '@mui/x-data-grid';
import { Restaurant as UtensilsIcon } from '@mui/icons-material';
import type { Recipe } from '@/types/recipe';

interface RecipeGridProps {
  recipes: Recipe[];
  onRecipeClick: (recipeId: number) => void;
  totalRecipes: number;
  onPageChange: (model: GridPaginationModel) => void;
  loading: boolean;
  pageSize?: number;
  page?: number;
}

const ListView = ({ recipes, onRecipeClick, totalRecipes, onPageChange, loading, pageSize = 20, page = 0 }: RecipeGridProps) => {
  const { t } = useTranslation();
  const [filterModel, setFilterModel] = useState({
    items: [],
    quickFilterValues: [],
  });
  const columns: GridColDef<Recipe>[] = [
    {
      field: 'icon',
      headerName: '',
      width: 60,
      sortable: false,
      filterable: false,
      renderCell: () => (
        <Box sx={{ bgcolor: 'primary.light', p: 1, borderRadius: '50%', display: 'inline-flex' }}>
          <UtensilsIcon color="primary" />
        </Box>
      ),
    },
    { field: 'name', headerName: t('recipes.list.columns.recipeName'), flex: 1 },
    { field: 'price', headerName: t('recipes.list.columns.price'), flex: 1, type: 'number' },
    { field: 'cost', headerName: t('recipes.list.columns.cost'), flex: 1, type: 'number' },
    { field: 'beneficio', headerName: t('recipes.list.columns.profit'), flex: 1, type: 'number' },
    { field: 'margen', headerName: t('recipes.list.columns.margin'), flex: 1, type: 'number' },
  ];

  return (
    <DataGrid
      rows={recipes}
      columns={columns}
      paginationMode="server"
      rowCount={totalRecipes}
      loading={loading}
      pageSizeOptions={[10, 20, 50, 100]}
      initialState={{
        pagination: {
          paginationModel: { page, pageSize },
        },
      }}
      onPaginationModelChange={onPageChange}
      onRowClick={(params) => onRecipeClick(params.row.id)}
      autoHeight
      disableRowSelectionOnClick
      sx={{
        '& .MuiDataGrid-row': {
          cursor: 'pointer',
        },
      }}
      filterModel={filterModel}
      onFilterModelChange={setFilterModel}
      disableColumnFilter
    />
  );
};

export default ListView;
